module.exports = __webpack_public_path__ + "static/media/amst.a9ffbe59.jpg";